import type { AppRouteModule } from '/@/router/types';
import { LAYOUT } from '/@/router/constant';

const opRoutes: AppRouteModule[] = [
  {
    path: '/',
    name: 'OpSys',
    component: LAYOUT,
    redirect: '/op/home',
    meta: {
      icon: 'stash:dashboard',
      title: '总览',
      hideChildrenInMenu: true,
      hideBreadcrumb: true,
    },
    children: [
      {
        path: '/op/home',
        name: 'Home',
        component: () => import('/src/views/op/home/index.vue'),
        meta: {
          title: '总览',
        },
      },
    ],
  },
  {
    path: '/group',
    name: 'OpGroup',
    component: LAYOUT,
    redirect: '/op/group',
    meta: {
      icon: 'fluent:group-list-24-regular',
      title: '分组管理',
      hideChildrenInMenu: true,
    },
    children: [
      {
        path: '/op/group',
        name: 'Group',
        component: () => import('/src/views/op/group-manager/index.vue'),
        meta: {
          title: '分组管理',
        },
      },
      {
        path: '/op/group/detail',
        name: 'Group-Detail',
        component: () => import('/src/views/op/group-detail/index.vue'),
        meta: {
          title: '分组详情',
          currentActiveMenu: '/op/group',
        },
      },
    ],
  },
  {
    path: '/device',
    name: 'OpDevice',
    component: LAYOUT,
    redirect: '/op/device',
    meta: {
      icon: 'mingcute:device-fill',
      title: '设备管理',
      hideChildrenInMenu: true,
      hideBreadcrumb: true,
    },
    children: [
      {
        path: '/op/device',
        name: 'Device',
        component: () => import('/src/views/op/device-manager/index.vue'),
        meta: {
          title: '设备管理',
        },
      },
    ],
  },
  {
    path: '/version',
    name: 'OpVersion',
    component: LAYOUT,
    redirect: '/op/version',
    meta: {
      icon: 'qlementine-icons:version-control-16',
      title: '版本管理',
      hideChildrenInMenu: true,
      hideBreadcrumb: true,
    },
    children: [
      {
        path: '/op/version',
        name: 'Op-Version',
        component: () => import('/src/views/op/version/index.vue'),
        meta: {
          title: '版本管理',
        },
      },
    ],
  },
  {
    path: '/op',
    name: 'OpManager',
    component: LAYOUT,
    meta: {
      icon: 'lsicon:operation-outline',
      title: '运维管理',
    },
    children: [
      {
        path: '/op/group-stat',
        name: 'Op-Manager-Group-Stat',
        component: () => import('/src/views/op/op-manager/group-stat/index.vue'),
        meta: {
          title: '分组统计',
        },
      },
      {
        path: '/op/activity-alarm',
        name: 'Op-Manager-ActivityAndAlarm',
        component: () => import('/src/views/op/op-manager/activity-alarm/index.vue'),
        meta: {
          title: '活动量有效及告警事件统计',
        },
      },
      {
        path: '/op/event-stat',
        name: 'Op-Manager-EventStat',
        component: () => import('/src/views/op/op-manager/event-stat/index.vue'),
        meta: {
          title: '告警事件统计',
        },
      },
      {
        path: '/op/fall-device',
        name: 'Op-Manager-FallDevice',
        component: () => import('/src/views/op/op-manager/fall-device/index.vue'),
        meta: {
          title: '跌倒设备统计',
        },
      },
    ],
  },
  // {
  //   path: '/stock',
  //   name: 'OpStock',
  //   component: LAYOUT,
  //   redirect: '/op/stock/package',
  //   meta: {
  //     icon: 'ion:grid-outline',
  //     title: '库存管理',
  //   },
  //   children: [
  //     {
  //       path: '/op/stock/package',
  //       name: 'stock-package',
  //       component: () => import('/src/views/op/stock/package/index.vue'),
  //       meta: {
  //         title: '库存单元',
  //       },
  //     },
  //     {
  //       path: '/op/stock/in',
  //       name: 'stock-in',
  //       component: () => import('/src/views/op/stock/in/index.vue'),
  //       meta: {
  //         title: '入库',
  //       },
  //     },
  //     {
  //       path: '/op/stock/out',
  //       name: 'stock-out',
  //       component: () => import('/src/views/op/stock/out/index.vue'),
  //       meta: {
  //         title: '出库',
  //       },
  //     },
  //     {
  //       path: '/op/stock/count',
  //       name: 'stock-count',
  //       component: () => import('/src/views/op/stock/count/index.vue'),
  //       meta: {
  //         title: '盘点',
  //       },
  //     },
  //     {
  //       path: '/op/stock/kanban',
  //       name: 'stock-kanban',
  //       component: () => import('/src/views/op/stock/kanban/index.vue'),
  //       meta: {
  //         title: '看板',
  //       },
  //     },
  //   ],
  // },

  // {
  //   path: '/logs',
  //   name: 'Oplogs',
  //   component: LAYOUT,
  //   redirect: '/op/logs',
  //   meta: {
  //     icon: 'octicon:log-16',
  //     title: '操作日志',
  //     hideChildrenInMenu: true,
  //     hideBreadcrumb: true,
  //   },
  //   children: [
  //     {
  //       path: '/op/logs',
  //       name: 'Op-Logs',
  //       component: () => import('/src/views/op/logs/index.vue'),
  //       meta: {
  //         title: '操作日志',
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: '/visualization',
  //   name: 'visualization',
  //   component: LAYOUT,
  //   redirect: '/visualization/grafana',
  //   meta: {
  //     icon: 'carbon:text-link-analysis',
  //     title: '数据管理',
  //   },
  //   children: [
  //     {
  //       path: 'grafana',
  //       name: 'Grafana',
  //       component: () => import('/@/views/op/visualization/Grafana.vue'),
  //       meta: {
  //         // affix: true,
  //         icon: 'simple-icons:grafana',
  //         title: '数据可视化',
  //       },
  //     },
  //   ],
  // },
  {
    path: '/tools',
    name: 'Tools',
    component: LAYOUT,
    redirect: '/tools/index',
    meta: {
      icon: 'ri:tools-fill',
      title: '工具',
    },
    children: [
      {
        path: 'config-net',
        name: 'Op-Config-Net',
        component: () => import('/src/views/op/tools/device-config-net.vue'),
        meta: {
          title: '蓝牙配网',
        },
      },
      {
        path: 'mock-alert',
        name: 'Op-Mock-Alert',
        component: () => import('/src/views/op/tools/mock-alert/mock-alert.vue'),
        meta: {
          title: '模拟告警',
        },
      },
      {
        path: 'floor-plan',
        name: 'Op-Floor-Plan',
        component: () => import('/src/views/op/tools/down-floor-plan/index.vue'),
        meta: {
          title: '户型图下发',
        },
      },
      {
        path: 'floor-plan-records',
        name: 'Op-Floor-Plan-Records',
        component: () => import('/src/views/op/tools/down-floor-plan/records.vue'),
        meta: {
          title: '户型图下发明细',
          hideMenu: true,
          currentActiveMenu: '/tools/floor-plan',
        },
      },
      {
        path: 'floor-plan-view',
        name: 'Op-Floor-Plan-View',
        component: () => import('/@/views/op/big-screen/floor-plan/index.vue'),
        meta: {
          title: '户型图查询',
        },
      },
    ],
  },
  // {
  //   path: '/llm',
  //   name: 'OpLLM',
  //   component: LAYOUT,
  //   redirect: '/op/llm',
  //   meta: {
  //     icon: 'ri:robot-fill',
  //     title: 'AI助手',
  //     hideChildrenInMenu: true,
  //     hideBreadcrumb: true,
  //   },
  //   children: [
  //     {
  //       path: '/op/llm',
  //       name: 'Op-LLM',
  //       component: () => import('/src/views/op/llm/index.vue'),
  //       meta: {
  //         title: 'AI助手',
  //       },
  //     },
  //   ],
  // },
];

export default opRoutes;
